import { render, staticRenderFns } from "./Costo.vue?vue&type=template&id=2dc0a071&scoped=true"
import script from "./Costo.vue?vue&type=script&lang=js"
export * from "./Costo.vue?vue&type=script&lang=js"
import style0 from "./Costo.vue?vue&type=style&index=0&id=2dc0a071&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0a071",
  null
  
)

export default component.exports